"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHover = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
const useHover = (iconOnHover, icon, hidden) => {
  const [isHover, setIsHover] = (0, _react.useState)(false);
  const ref = (0, _react.useRef)(null);
  const isHoverAvailable = (0, _mui.useMediaQuery)('(hover: hover)');
  const getIcon = (0, _react.useMemo)(() => {
    if (isHover) {
      return iconOnHover;
    }
    return icon;
  }, [isHover, icon, iconOnHover]);
  const handleMouseOver = (0, _react.useCallback)(() => {
    setIsHover(true);
  }, []);
  const handleMouseLeave = (0, _react.useCallback)(() => {
    setIsHover(false);
  }, []);
  (0, _react.useEffect)(() => {
    const element = ref.current;
    if (isHoverAvailable && !hidden) {
      element?.addEventListener('mouseover', handleMouseOver);
      element?.addEventListener('mouseleave', handleMouseLeave);
    }
    return () => {
      if (isHoverAvailable && !hidden) {
        element?.removeEventListener('mouseover', handleMouseOver);
        element?.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [isHoverAvailable, handleMouseOver, handleMouseLeave, hidden]);
  return [ref, getIcon];
};
exports.useHover = useHover;